import StandardGateway from 'scripts/adapters/gateways/lib/standard_gateway';

const UPLOAD_FILE_TIMEOUT = 60000; // 60 sec

export default class AgentUserUploadsGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v3/agent_user_uploads');
  }

  uploadCsv({ file }) {
    const url = this.endpoint.set({}).fetchUrl;

    return this.http.post(url, file, { timeout: UPLOAD_FILE_TIMEOUT }).catch(error => {
      throw error;
    });
  }
}
